var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "650px",
        title: "导入数据集字段列表（使用模板）",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        close: _vm.closeHandle,
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-upload",
        {
          staticStyle: { "text-align": "center" },
          attrs: {
            drag: "",
            action: _vm.uploadUrl,
            accept: ".xls,.xlsx",
            "on-success": _vm.successHandle,
            multiple: false,
            name: _vm.fileName,
            "show-file-list": false,
          },
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v("将文件拖到此处，或"),
            _c("em", [_vm._v("点击上传")]),
          ]),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [_vm._v("只支持xls、xlsx格式的表格")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }